import Media from './../mediaDetect.js'; //Детектор медиа
import Twig from 'twig';
import Calendar from './../components/calendar.js';
import LiveSearch from './../components/live-search.js';

/*
 * Скрипты для страницы Пресс-центр
*/

const ToggleNewsView = function (listClass) {
    let btns = $('[data-toggle-news-view-type]')
    let newsList = $('.' + listClass)[0]

    ToggleNewsView.init = function () {
        ToggleNewsView.events()
    }

    ToggleNewsView.getCookie = function (name) {
        let matches = document.cookie.match(new RegExp(
            "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
        ));
        return matches ? decodeURIComponent(matches[1]) : undefined;
    }

    ToggleNewsView.setCookie = function (name, value, options = {}) {
        if (options.expires && options.expires.toUTCString) {
            options.expires = options.expires.toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (let optionKey in options) {
            updatedCookie += "; " + optionKey;
            let optionValue = options[optionKey];
            if (optionValue !== true) {
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    ToggleNewsView.events = function () {
        btns.click(function (e) {
            let mode = $(this).data('toggle-news-view')

            newsList.dataset.newsListMode = mode
            ToggleNewsView.setCookie('newsListMode', mode)
        })
    }
}

let langId = window.langId;
let NewsFilter = {
    name: '',
    dateStart: '', // глобальная дата, которая передаётся в качестве параметра фильтрации
    dateFinish: '' // глобальная дата, которая передаётся в качестве параметра фильтрации
}

let isClearSearchNews = true,
    currEventsListPage = 1,
    currParamsUrs = ''; // хранит параметры урла - интервал дат и тип мероприятия

let NewsLiveSearchOptions = {};


let News = {
    initSearch: function() {

        let btnClearSearchNews = $('[data-clear-search-news-filter]');
        if(btnClearSearchNews.length){
            btnClearSearchNews.on('click', function(){
                // Очищаем поле поиска
                News.clearSearch();
                // Если изменилось значение поля поиска, то сбрасываем текущую страницу на 1
                currEventsListPage = 1;
                // Обновляем список новостей
                NewsFilter.name = '';
                News.ajaxFilter();
            });
        }

        let inputSearchNews = $('[data-input-search-news-filter]');
        inputSearchNews.on('blur', function(){
            if($(this).val() == ''){
                btnClearSearchNews.removeClass('show');
            }else{
                btnClearSearchNews.addClass('show');
            }
            News.setDataForSearch($(this));
        });

        // По клику на иконку поиска, обновляем список мероприятий
        let btnSearchNews = $('[data-btn-search-news-filter]');
        if(btnSearchNews.length) {
            btnSearchNews.on('click', function(){
                News.setDataForSearch(inputSearchNews);
            });
        }

        // По клавише enter, обновляем список мероприятий с учётом поля поиска
        let calendarNewsForm = $('[data-news-search-form]');
        if(calendarNewsForm.length) {
            calendarNewsForm.on('submit', function(e){
                e.preventDefault();
                News.setDataForSearch(inputSearchNews);
            });
        }
    },

    clearSearch: function() {
        NewsFilter.name = '';
        $('[data-input-search-news-filter]').val('');
        $('[data-clear-search-news-filter]').removeClass('show');
    },

    setDataForSearch: function(searchField) {
        // Устанавливаем значение для глобального параметра фильтрации
        NewsFilter.name = searchField.val();

        // Очищаем параметры фильтрации для поля даты
        Calendar.clearCalendar();
        $('[data-clear-filter-calendar]').removeClass('show');

        // Устанавливаем для типа мероприятия дефолтное значение, а при изменении значения
        // запускается аякс фильтрации
        isClearSearchNews = false;
    },

    getJsonFromUrl: function(){
      var query = location.search.substr(1);
      var result = {};
      query.split("&").forEach(function(part) {
        var item = part.split("=");
        result[item[0]] = decodeURIComponent(item[1]);
      });
      return result;
    },

    ajaxAdd: function(btn) {
        let typeAjax = btn.data('show-more-news'),
            currPage = btn.data('curr-page-show-more-news');

        let navNum = btn.data('nav-num');
        let currTab = btn.closest('[data-tab-filter]');
        let section = currTab.data('tab-filter');

        $.ajax({
            url: '/'+window.langId+'/ajax/news-list.php',
            data: {
                page: currPage + 1,
                section: section,
                data: NewsFilter,
            },
            dataType: 'json',
            beforeSend: function(){},
            success: function(_data){
                let container = btn.closest('[data-ajax-container]'),
                    listNews = container.find('[data-list-news]');

                btn.data('curr-page-show-more-news', currPage + 1);

                if(currPage + 1 >= _data.NAV_RESULT.pageCount){
                    btn.hide();
                }



                News.renderItems(_data.list, listNews);
                News.renderPagination(_data.NAV_RESULT, container, navNum, container.hasClass('active'));
            }
        });

    },

    /**
     * Добавляет элементы в контейнер
     *
     * @param {*} items
     * @param {*} container
     */
    renderItems(items, container, clearOldItems = false) {

        if(clearOldItems) {
            container.html('');
        }

        if(items != undefined && items.length > 0) {

            var template = Twig.twig({
                data:   '<div class="news-card__wrap">'+
                            '<div class="news-card">'+
                                '<div class="news-card__img-wrap">'+
                                    '<a href="{{ data.link }}" {% if data.isExternal %}target="_blank"{% endif %} class="news-card__img" style="background-image: url(\'{{ data.img }}\')"></a>'+
                                '</div>'+
                                '<div class="news-card__content">'+
                                    '{% if data.newspaper|length %}'+
                                        '<div class="news-card__newspaper">'+
                                            '<a href="{{ data.newspaper.link }}" class="news-card__newspaper-link">{{ data.newspaper.title|raw }}</a>'+
                                        '</div>'+
                                    '{% endif %}'+
                                    '<a href="{{ data.link }}" class="news-card__date">{{ data.date|raw }}</a>'+
                                    '<a href="{{ data.link }}" class="news-card__title">{{ data.title|raw }}</a>'+
                                '</div>'+
                            '</div>'+
                        '</div>'
            });

            items.forEach(function(item, i) {
                container.append(template.render({
                    data: {
                        link: item.link,
                        isExternal: item.isExternal,
                        img: item.img,
                        title: item.title,
                        date: item.date,
                        newspaper: item.newspaper
                    }
                }));
            });

        } else {
            if($("html").attr("lang") === "en") {
                container.html('No news found for your request.');
            }else{
                container.html('По вашему запросу новостей не найдено.');
            }
        }
    },

    /**
     * Рендерит пагинацию
     */
    renderPagination(navResult, container, navNum, isSetHistory) {
        let curLoc = window.location.href.slice(0,window.location.href.indexOf('\?'));

        if(navNum === "undefined"){
            navNum = navResult.NavNum;
        }

        if(isSetHistory) {
            history.pushState(null, null, curLoc + '?AJAX_RELOAD=Y&PAGEN_' + navNum + '=' + navResult.NavPageNomer);
        }

        let pagination = container.find('.news-list__pagination');
        pagination.find('.pagination').remove();

        if(navResult.NavPageCount > 1) {
            var templatePagination = Twig.twig({
              data: '<div class="pagination">'+
                      '{% if data.currentPage == 1 %}'+
                          '<div class="pagination__prev disabled">'+
                              '<span class="svg-icon">'+
                                  '<svg>'+
                                    '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use>'+
                                  '</svg>'+
                              '</span>'+
                          '</div>'+
                      '{% else %}'+
                          '<a href="?PAGEN_{{ data.navNum }}={{  data.currentPage - 1 }}" class="pagination__prev">'+
                              '<span class="svg-icon">'+
                                  '<svg>'+
                                    '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use>'+
                                  '</svg>'+
                              '</span>'+
                          '</a>'+
                      '{% endif %}'+

                      '<div class="pagination__content">'+
                        '<span class="pagination__current-page">{{data.currentPage}}</span>'+
                        '<span class="">{% if data.strOf is empty %} из {% else %} {{ data.strOf }} {% endif %} {{data.countAllPage}}</span>'+
                      '</div>'+

                      '{% if data.currentPage == data.countAllPage or data.countAllPage == 0 %}'+
                          '<div class="pagination__next disabled">'+
                              '<span class="svg-icon">'+
                                  '<svg>'+
                                    '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use>'+
                                  '</svg>'+
                              '</span>'+
                          '</div>'+
                      '{% else %}'+
                          '<a href="?PAGEN_{{ data.navNum }}={{ data.currentPage + 1 }}" class="pagination__next">'+
                              '<span class="svg-icon">'+
                                  '<svg>'+
                                    '<use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#spr-arrow-right"></use>'+
                                  '</svg>'+
                              '</span>'+
                          '</a>'+
                      '{% endif %}'+
                  '</div>'
            });

            pagination.append(templatePagination.render({
                data: {
                    navNum: navNum,
                    currentPage: navResult.NavPageNomer,
                    strOf: navResult.strOf,
                    countAllPage: navResult.NavPageCount,
                    listUrl: navResult.strListUrl,
                }
            }));

        }

    },

    /**
     * Фильтрует список новостей
     */
    ajaxFilter(isSetPage) {
        let $ajaxContainer = $('[data-ajax-container]');

        $ajaxContainer.each(function() {

            let $container = $(this);
            let $listNews = $container.find('[data-list-news]');
            let section = $container.data('tab-filter');
            let $btn = $container.find('[data-show-more-news]');
            let navNum = $btn.data('nav-num');

            let paramsUrl = News.getJsonFromUrl(),
                _page = 1;

            if($container.hasClass('active') && paramsUrl['PAGEN_1'] && isSetPage) {
                _page = parseFloat(paramsUrl['PAGEN_1']);
            }

            $.ajax({
                url: '/' + window.langId + '/ajax/news-list.php',
                data: {
                    section: section,
                    page: _page,
                    data: NewsFilter,
                },
                dataType: 'json',
                beforeSend: function() {},
                success: function(_data) {
                    $btn.data('curr-page-show-more-news', _page);

                    if(_data.NAV_RESULT.pageCount <= 1){
                        $btn.hide();
                    } else {
                        $btn.show();
                    }

                    News.renderItems(_data.list, $listNews, true);
                    News.renderPagination(_data.NAV_RESULT, $container, navNum, $container.hasClass('active'));
                }
            });

        });

    },
}



$(document).ready(function($) {
    if ($('.news-list').length) {
        ToggleNewsView('news-list')
        let newsMode = ToggleNewsView.getCookie('newsListMode')
        let news = document.querySelector('[data-news-list-mode]')

        if (newsMode) {
          news.dataset.newsListMode = newsMode
        } else {
          news.dataset.newsListMode = 'grid'
          ToggleNewsView.setCookie('newsListMode', 'grid')
        }

        ToggleNewsView.init();

        $(window).on('change:calendar', function(e, CalendarFilter) {

            // Если изменилось значение даты, то сбрасываем текущую страницу на 1
            currEventsListPage = 1;

            NewsFilter.dateStart = CalendarFilter.dateStart;
            NewsFilter.dateFinish = CalendarFilter.dateFinish;

            if (NewsFilter.dateStart != '' && NewsFilter.dateFinish != '') {
                News.clearSearch();
                $('[data-clear-filter-calendar]').addClass('show');
            }
            News.ajaxFilter();
        })

        let calendarDateVal = Calendar.getCalendarFilter();
        if((calendarDateVal.dateStart !== '') && (calendarDateVal.dateFinish !== '')) {
            NewsFilter.dateStart = calendarDateVal.dateStart;
            NewsFilter.dateFinish = calendarDateVal.dateFinish;

            $('[data-clear-filter-calendar]').addClass('show');
            News.ajaxFilter(true);
        }
    }

    // Инициализируем поле поиска
    News.initSearch();

    if ($('[data-news-search-form]').length) {
        // Живой поиск
        LiveSearch.init();
    }

    $(document).on('click', '[data-show-more-news]', function(e){
        e.preventDefault();
        News.ajaxAdd($(this));
    });

    let $liveSearchFilter = $('[data-live-search-filter]');
    if($liveSearchFilter.length) {
        NewsLiveSearchOptions.section = $liveSearchFilter.data('live-search-filter');
        let $newsLiveSearch = $('[data-news-search-form]').find('[data-live-search]');
        if($newsLiveSearch.length) {
            $newsLiveSearch.data('live-search-options', JSON.stringify(NewsLiveSearchOptions));
        }
    }

    $(document).on('click', '[data-item-nav-tabs]', function() {
        $.cookie('news-list_tab', $(this).data('item-nav-tabs'));
    });

});



// WEBPACK FOOTER //
// ./pages/news.js